import { render, staticRenderFns } from "./VerticalLayoutLessContent.vue?vue&type=template&id=a71b5330"
import script from "./VerticalLayoutLessContent.vue?vue&type=script&lang=js"
export * from "./VerticalLayoutLessContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports